import React from "react" ;
import UsersAppBodyHeader from "./UsersAppBodyHeader";
import {Route, Switch} from "react-router-dom";

import {PATH_USERS_ROOT, PATH_USERS_DASHBOARD, PATH_USERS_CONNECTIONS, PATH_USERS_SUMMARY} from "root/Wieldy/routePaths";
import ScrollRails from "../../Common/Body/ScrollRails";
import UsersTab from "root/Wieldy/ApplicationModules/Users/Body/UsersTab";
import UsersDashboardTab from "root/Wieldy/ApplicationModules/Users/Body/UserDashboards/UsersDashboardTab";
import ConnectionsTab from "root/Wieldy/ApplicationModules/Child/Body/ChildConnections/ConnectionsTab";

const UsersAppBody= (props) =>
{
    return (
    <div className="dt-module__container">
        <UsersAppBodyHeader />
        <div className="dt-module__content ps-custom-scrollbar ps" style={{height: props.height, width: props.width}}>
            <div className="dt-module__content-inner">
                <div className="dt-module__list">
                    <Switch>
                        <Route path={PATH_USERS_DASHBOARD} render={(thisprops) => <UsersDashboardTab {...thisprops}/>}/>
                        <Route path={PATH_USERS_SUMMARY} render={(thisprops) => <UsersDashboardTab {...thisprops}/>}/>
                        <Route path={PATH_USERS_CONNECTIONS}render={(thisprops) => <ConnectionsTab {...thisprops}/>}/>
                        <Route path={PATH_USERS_ROOT}render={(thisprops) => <UsersTab user_id='' {...thisprops}/>}/>
                    </Switch>
                </div>
            </div>
            <ScrollRails />
        </div>
    </div>
    ) ;
}

export default UsersAppBody;
